import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { useTheme } from '../../themes/ThemeProvider';
export const Link = ({ variant = 'default', className = '', asButton = false, children, ...props }) => {
    const theme = useTheme();
    const baseStyle = {
        color: variant === 'footer' ? (theme.linkFooterColor ?? '#1F1F1F') : (theme.linkDefaultColor ?? '#1573D3'),
        fontSize: variant === 'footer' ? (theme.linkFooterFontSize ?? 14) : (theme.linkDefaultFontSize ?? 12),
        textDecoration: 'underline',
        fontWeight: 400,
        cursor: 'pointer',
        transition: 'color 0.2s',
        background: 'none',
        border: 'none',
        padding: 0,
        fontFamily: 'inherit',
    };
    if (asButton) {
        const buttonProps = props;
        return (_jsx("button", { type: 'button', style: { ...baseStyle, ...buttonProps.style }, className: className, ...buttonProps, children: children }));
    }
    const anchorProps = props;
    return (_jsx("a", { style: { ...baseStyle, ...anchorProps.style }, className: className, ...anchorProps, children: children }));
};
